import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useMemo } from 'react';
import classnames from 'classnames';
import { URLS } from '@wix/da-url';
import { useTranslation, Trans } from 'react-i18next';
import StreamedList from '../../StreamedList';
import Modal from '../../Popup/Modal';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import BackgroundThumbList from './BackgroundThumbList';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import { DEFAULT_BACKGROUND_ID } from '../redux/constants';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import s from './BackgroundPickerPopup.scss';
function filterBackgrounds(backgrounds) {
    if (!backgrounds.length) {
        return {
            free: [],
            core: []
        };
    }
    return {
        free: [
            {
                backgroundId: DEFAULT_BACKGROUND_ID
            },
            ...backgrounds.filter((bg)=>!bg.isPremium)
        ],
        core: backgrounds.filter((bg)=>bg.isPremium)
    };
}
const BackgroundPickerPopup = ({ streamId, backgrounds, requestClose, canUseCore, currentBackgroundId = DEFAULT_BACKGROUND_ID, onBackgroundPreviewed, onBackgroundPicked, deviation, isFetching, variant })=>{
    var _deviation_background;
    const { t } = useTranslation();
    const logEvent = useBiLogger();
    const deviationTypeId = getDeviationResourceType(deviation);
    const deviationContext = useMemo(()=>({
            itemid: deviation.deviationId,
            typeid: deviationTypeId
        }), [
        deviation.deviationId,
        deviationTypeId
    ]);
    const requestCloseCallback = useCallback(()=>{
        var _deviation_background;
        logEvent(BiData({
            evid: 374,
            background_id: currentBackgroundId,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            core_only: ((_deviation_background = deviation.background) === null || _deviation_background === void 0 ? void 0 : _deviation_background.isPremium) ? 1 : 0
        }));
        requestClose();
    }, [
        logEvent,
        currentBackgroundId,
        (_deviation_background = deviation.background) === null || _deviation_background === void 0 ? void 0 : _deviation_background.isPremium,
        requestClose
    ]);
    const { free, core } = filterBackgrounds(backgrounds);
    const commonThumbProps = {
        variant,
        canUseCore,
        onBackgroundPicked: (backgroundId)=>onBackgroundPicked(deviation, backgroundId),
        onBackgroundPreviewed,
        currentBackgroundId
    };
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: deviationContext
    }, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: true,
        onRequestClose: requestCloseCallback,
        className: classnames(s['popover'], s[`popover-${variant}`]),
        contentClassName: classnames('ds-surface-tertiary', s['root']),
        closeBtnButtonClassName: s['close-button'],
        overlayClassName: s['overlay'],
        allowThemeSkins: true // need theme skins for css variables in green theme to work...
        ,
        withCloseButton: true,
        closeBtnSize: IconSize.SMALL
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, t('deviation.backgrounds.customize')), /*#__PURE__*/ React.createElement(StreamedList, {
        wrapperClassName: s['list-wrapper'],
        className: s['list'],
        streamId: streamId
    }, /*#__PURE__*/ React.createElement(BackgroundThumbList, _object_spread({
        title: t('deviation.backgrounds.freeBackgrounds'),
        backgrounds: free
    }, commonThumbProps)), /*#__PURE__*/ React.createElement(BackgroundThumbList, _object_spread({
        title: t('deviation.backgrounds.premiumBackgrounds'),
        backgrounds: core
    }, commonThumbProps)), isFetching && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        className: s['loader']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['footer']
    }, !canUseCore && /*#__PURE__*/ React.createElement("div", {
        className: s['core-upsell']
    }, /*#__PURE__*/ React.createElement(BiLink, {
        href: URLS.CORE_MEMBERSHIP,
        biData: BiData({
            evid: 375,
            referral_info: ReferralType.BACKGROUND_MODAL
        })
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "deviation.backgrounds.becomeCoreToAccess"
    }, "Become", ' ', /*#__PURE__*/ React.createElement(CoreBadge, {
        className: s['core-badge'],
        size: "small"
    }), " to access more backgrounds for your art"))))));
};
export default BackgroundPickerPopup;

//# sourceMappingURL=BackgroundPickerPopup.js.map